import { useSelector } from "react-redux";
import { selectCartesianSteps } from "../../../Cartesian/store/slices/cartesian";
import { selectIntegratedDrivesSteps } from "../../../IntegratedDrives/store/slices/integrated_drives";
import { selectMc12Steps } from "../../../Mc12/store/slices/mc12";
import { selectRetrofitSteps } from "../../../Retrofit/store/slices/retrofit";

// Get all the steps of retrofit, cartesian and other configuration types
export const getAllSteps = () => {
  const retrofitSteps = useSelector(selectRetrofitSteps);
  const cartesianSteps = useSelector(selectCartesianSteps);
  const mc12Steps = useSelector(selectMc12Steps);
  const integratedDrivesSteps = useSelector(selectIntegratedDrivesSteps);
  return {
    retrofit: retrofitSteps,
    cartesian: cartesianSteps,
    mc12: mc12Steps,
    integratedDrives: integratedDrivesSteps
  };
};

export const isStartStep = (step) => {
  const retrofitSteps = useSelector(selectRetrofitSteps);
  const cartesianSteps = useSelector(selectCartesianSteps);
  const mc12Steps = useSelector(selectMc12Steps);
  const integratedDrivesSteps = useSelector(selectIntegratedDrivesSteps);
  return (
    step === retrofitSteps.START ||
    step === cartesianSteps.START ||
    step === mc12Steps.START ||
    step === integratedDrivesSteps.START
  );
};

export const isNumber = (value) => /^-?\d+$/.test(value);
